import { CTA, CTAProps } from '@/components/CTA';
import classNames from 'classnames';
import React from 'react';
import styles from './CtaGroup.module.scss';

export interface CtaGroupProps {
  ctas: CTAProps[];
  className?: string;
}

export const CtaGroup: React.FC<CtaGroupProps> = ({ ctas, className }) => {
  return (
    <div className={classNames(styles.cta_group, className)}>
      {ctas.map((cta, index) => (
        <CTA key={index} {...cta} className={styles.cta} />
      ))}
    </div>
  );
};
